import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import {
  ROUTER_PATHS,
  a11yProps,
  hasPermission,
  sizeTab,
  texto,
  useCheckPermissions,
} from "@/shared";
import ProspectoRealizadoPage from "./prospecto-realizado/ProspectoRealizadoPage";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import ProspectoRechazadoPage from "./prospecto-rechazado/ProspectoRechazadoPage";
import ProspectoEsperaPage from "./prospecto-espera/ProspectoEsperaPage";
import { PermissionsEnum } from "@/auth/interfaces";

export default function ProspectoPagina() {
  useCheckPermissions(PermissionsEnum.api_view_prospecto);

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Prospectos"}
      py={2}
      enableRedirect={hasPermission(PermissionsEnum.api_add_prospecto)}
      urlRedirect={
        hasPermission(PermissionsEnum.api_add_prospecto)
          ? ROUTER_PATHS.ventas.prospectoCrear
          : undefined
      }
      visibleReport={true}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Prospecto"} {...a11yProps(0)} />
          <Tab label={"Finalizadas"} {...a11yProps(1)} />
          <Tab label={texto.cancelado} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <ProspectoEsperaPage />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <ProspectoRealizadoPage />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <ProspectoRechazadoPage />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}
